import { Checkbox } from 'antd';
import { ThemeProvider } from 'styled-components';

import {
  ModalContent,
  ModalTitle,
  ModalDescription,
  CheckboxContainer
} from './ConfirmUploadModal.styles';

import { defaultTheme } from '@/styles/theme';

interface ModalContentComponentProps {
  title: string;
  description: string;
  dontShowAgainLabel: string;
  onCheckChange: (checked: boolean) => void;
}

export const ModalContentComponent: React.FC<ModalContentComponentProps> = ({
  title,
  description,
  dontShowAgainLabel,
  onCheckChange
}) => (
  <ThemeProvider theme={defaultTheme}>
    <ModalContent>
      <ModalTitle>{title}</ModalTitle>
      <ModalDescription>{description}</ModalDescription>
      <CheckboxContainer>
        <Checkbox onChange={e => onCheckChange(e.target.checked)}>{dontShowAgainLabel}</Checkbox>
      </CheckboxContainer>
    </ModalContent>
  </ThemeProvider>
);
